import React from 'react';

const Button = ({
  label,
  variant = 'primary',
  size = 'md',
  onClick,
  type = 'button',
  className = '',
  disabled = false,
  children,
}) => {
  const baseStyles = 'rounded-lg font-medium focus:outline-none transition-all duration-200 ease-in-out';

  const variants = {
    primary: 'bg-primary-900 text-white hover:bg-primary-400',
    secondary: 'bg-white shadow-lg hover:bg-primary-50 rounded',
    outline: 'border-[1.5px] border-primary-900 text-defaultText bg-primary-50',
    danger: 'bg-red-500 text-white hover:bg-red-600',
  };

  const sizes = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };

  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';

  const finalClassName = `${baseStyles} ${variants[variant] || ''} ${sizes[size] || ''} ${disabledStyles} ${className}`;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={finalClassName}
    >
      {children || label}
    </button>
  );
};

export default Button;
